import { SECONDARY_SCHOOL_LEVELS, type SchoolLevel } from '@jeraisonne/db';

/**
 * Sélecteur de niveau (pills défilables) — utilisé côté joueur (« Espace
 * curieux ») qui n'a pas de niveau fixe pour choisir le Live School à consulter.
 */
export function LevelSelect({
  value,
  onChange,
}: {
  value: SchoolLevel | null;
  onChange: (level: SchoolLevel) => void;
}) {
  return (
    <div
      className="-mx-1 mb-4 flex gap-2 overflow-x-auto px-1 pb-1"
      role="group"
      aria-label="Choisir un niveau"
    >
      {SECONDARY_SCHOOL_LEVELS.map((l) => (
        <button
          key={l.value}
          type="button"
          onClick={() => onChange(l.value)}
          className={`min-h-10 shrink-0 rounded-full px-4 text-sm font-medium transition active:scale-[0.98] ${
            value === l.value ? 'bg-primary-500 text-white' : 'bg-ink-100 text-ink-600'
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
